import imageSearch from "../../assets/empty-results.png";

/* eslint-enable max-len */
export const DefaultSearch = {
  coverPublicURL: imageSearch,
  shortDescription:"change_key_search",
  title: "no_search_result"
};
